import type { MapSettings } from '../../admin/types';

const rows: { key: keyof MapSettings['legend']; label: string; hint: string }[] = [
  {
    key: 'groupByLayerGroup',
    label: 'Группировать по группам слоёв',
    hint: 'Записи легенды собираются под заголовками групп вместо плоского списка',
  },
  {
    key: 'showObjectCounts',
    label: 'Показывать количество объектов',
    hint: 'Число объектов слоя рядом с его названием',
  },
  {
    key: 'showOpacitySlider',
    label: 'Регулятор прозрачности',
    hint: 'Ползунок прозрачности прямо в легенде, без открытия панели «Слои и фильтры»',
  },
];

/** MapSettingsPage owns the draft (`form`) and the page-level Save button —
 * same pattern as SearchTab, this is just the controls. The autoOpenLegend
 * toggle stays where it already lived (BehaviorConfig, "Основные" tab) —
 * it's about the map's initial load state, not the legend's own content. */
export function LegendTab({
  legend,
  onChange,
}: {
  legend: MapSettings['legend'];
  onChange: (next: MapSettings['legend']) => void;
}) {
  return (
    <div className="px-8 py-6">
      <div className="mx-auto max-w-[560px]">
        <section className="rounded-2xl border border-border-default bg-bg-surface p-6">
          <h2 className="text-[15px] font-semibold text-text-primary">Легенда</h2>
          <p className="mt-1 text-xs text-text-secondary">
            Настройки списка слоёв в попапе легенды на панели инструментов карты.
          </p>

          <div className="mt-4 flex flex-col gap-4">
            {rows.map(({ key, label, hint }) => (
              <div key={key} className="flex items-center justify-between gap-4">
                <div className="min-w-0">
                  <p className="text-[13px] font-medium text-text-primary">{label}</p>
                  <p className="mt-0.5 text-[11px] text-text-secondary">{hint}</p>
                </div>
                <button
                  type="button"
                  onClick={() => onChange({ ...legend, [key]: !legend[key] })}
                  className={`flex h-[26px] w-[52px] shrink-0 items-center rounded-full px-1 transition-colors ${
                    legend[key] ? 'bg-action-primary justify-end' : 'bg-bg-surface-secondary justify-start'
                  }`}
                >
                  <span className="size-[18px] rounded-full bg-bg-surface shadow" />
                </button>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
